import { createAction, props } from '@ngrx/store';
import { Institution } from 'src/generated/graphql';

export const addToSaved = createAction(
  '[Saved] add to saved',
  props<{ institution: Institution }>()
);

export const addToSavedSuccess = createAction(
  '[Saved] add to saved success',
  props<{ institution: Institution }>()
);

export const addToSavedFailure = createAction(
  '[Saved] add to saved failure',
  props<{ message: string }>()
);

export const removeFromSaved = createAction(
  '[Saved] remove from saved',
  props<{ institution: Institution }>()
);

export const removeFromSavedSuccess = createAction(
  '[Saved] remove from saved success',
  props<{ institution: Institution }>()
);

export const removeFromSavedFailure = createAction(
  '[Saved] remove from saved failure',
  props<{ message: string }>()
);
